import { DialogContent as MuiDialogContent } from '@mui/material';

export default MuiDialogContent;
